'use client';

import React, { useState, useEffect } from 'react';
import styles from './SearchBar.module.scss';
import Image from 'next/image';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useEnvContext } from '@/context/envContext';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
interface SearchBarWithNoToggleProps {
  pageType: string;
}
export const SearchBar = () => {
  const [showMobileSearch, setShowMobileSearch] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const {
    cdnEnv
  } = useEnvContext();
  const MagGlass = `${cdnEnv}/rms/images/icons/mag-glass-icon.svg`;
  const toggleChecked = () => {
    setShowMobileSearch(prevToggleState => !prevToggleState);
    pushGTMClickTags({
      click_element: 'Button',
      click_closest_class: 'search-btn-togggle-container',
      click_section_ID: 'NONE',
      link_classes: 'search-btn-toggle search-toggle-block',
      link_id: 'NONE',
      link_text: 'Search toggle',
      link_url: 'NONE',
      click_category: 'NONE',
      click_destination: 'NONE',
      click_closest_href: 'NONE'
    });
  };
  const submitSearch = (event: any) => {
    const {
      search
    } = event.target.elements;
    event.preventDefault();
    setShowMobileSearch(prevToggleState => !prevToggleState);
    pushGTMClickTags({
      click_element: 'Input',
      click_closest_class: 'NONE',
      click_section_ID: 'NONE',
      link_classes: 'search-bar-button',
      link_id: 'NONE',
      link_text: search.value,
      link_url: '/search/',
      click_category: 'NONE',
      click_destination: '/search/',
      click_closest_href: 'NONE'
    });
    localStorage.setItem('searchTerm', search.value);
    localStorage.setItem('contentFilterType', 'resources');
    window.location.href = '/search/';
  };
  useEffect(() => {
    const notFoundElement = document.getElementsByClassName('not-found-page');
    if (notFoundElement?.[0]) {
      setShowSearch(false);
    }
  }, []);
  const t = useTranslations('Header');
  return <>
   {showSearch && <>
     <div className={classNames(styles['search-btn-toggle-container'], 'search-toggle-block')}>
      <button aria-label="Header Search Toggle" className={classNames(styles['search-btn-toggle'], showMobileSearch ? styles['mobile-active'] : '')} data-bdd="search-header-toggle" onClick={toggleChecked}>
       <span className={styles['icon']} aria-hidden="true">
        <Image src={MagGlass} width={'27'} height={'27'} alt={'Submit'} priority={true} />
       </span>
      </button>
     </div>
     <form role="search" className={classNames('search-form-module', styles['tt-site-search'])} data-bdd="search-form" method="get" onSubmit={submitSearch}>
      <div className={classNames('search-bar-wrapper', styles['search-bar'], showMobileSearch ? 'd-block mobile-active' : 'd-none d-md-block')} data-bdd="search-form-label">
       <input type="text" name="search" placeholder={t('SearchPlaceholder')} className={styles['search-bar-input']} data-bdd="search-form-input" />
       <button type="submit" aria-label="Search Button" className={classNames(styles['search-bar-button'], styles['search-bar-button-toggle'])} data-bdd="search-form-submit">
        <span className={styles['icon']} aria-hidden="true">
         <Image src={MagGlass} width={'27'} height={'27'} alt={'Submit'} priority={true} />
        </span>
       </button>
      </div>
     </form>
    </>}
  </>;
};
export const SearchBarWithNoToggle: React.FC<SearchBarWithNoToggleProps> = ({
  pageType
}) => {
  const submitSearch = (event: any) => {
    const {
      search
    } = event.target.elements;
    event.preventDefault();
    localStorage.setItem('searchTerm', search.value);
    localStorage.setItem('contentFilterType', 'resources');
    window.location.href = '/search/';
  };
  const {
    cdnEnv
  } = useEnvContext();
  const MagGlass = pageType === 'not-found' ? 'https://media.techtarget.com/rms/images/icons/mag-glass-icon.svg' : `${cdnEnv}/rms/images/icons/mag-glass-icon.svg`;
  const t = useTranslations('Header');
  return <>
   <form role="search" className={classNames('search-form-module', styles['tt-site-search'], styles['search-no-toggle'])} data-bdd="search-form" method="get" onSubmit={submitSearch}>
    <div className={classNames('search-bar-wrapper', styles['search-bar'], 'd-md-block')} data-bdd="search-form-label">
     <input type="text" name="search" placeholder={t('SearchPlaceholder')} className={styles['search-bar-input']} data-bdd="search-form-input" />
     <button type="submit" aria-label="Search Button" className={styles['search-bar-button']} data-bdd="search-form-submit">
      <span className={styles['icon']} aria-hidden="true">
       <Image src={MagGlass} width={'27'} height={'27'} alt={'Submit'} priority={true} data-sentry-element="Image" data-sentry-source-file="SearchBar.tsx" />
      </span>
     </button>
    </div>
   </form>
  </>;
};